import BrandLayout from '../../components/brand/BrandLayout';

import LoginContainer from '../../containers/authentication/login';

export default function LoginPage() {
  return (
    <BrandLayout>
      <LoginContainer />
    </BrandLayout>
  );
}
